import { Controller } from "@hotwired/stimulus"

// Administration, exceptions form: shows the hours / capacity fields only for
// "special hours" exceptions.
export default class extends Controller {
  static targets = ["specialOnly"]

  connect() {
    this.toggle()
  }

  toggle() {
    const kind = this.element.querySelector("input[name='schedule_exception[kind]']:checked")?.value
    this.specialOnlyTargets.forEach((element) => {
      element.hidden = kind !== "special_hours"
    })
  }
}
